
<template>    
    <v-dialog
      v-model="dialog"
      width="auto"
      
    >      
    <v-card v-if="detail">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
          pa-0
        >
          Movimientos de cliente
          
          <v-btn
            class="closeBtn"
            icon
            variant="text"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        
        
        <v-container style="padding-left: 20px;">
            <v-select
              :items="shipToAddresses"
              :item-text="shipToAddressesLabel"
              item-value="code"
              label="Filtro Dirección de envío"
              v-model="shipToAddress"
            ></v-select>
            <v-data-table
              v-if="windowSize.x >= 960"
                :headers="headers"
                :items="custLedgerEntries"
                class="elevation-1"
                hide-actions
            >
                <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.tipoDocumento }}</td>
                <td class="text-xs-center">{{ props.item.documento }}</td>
                <td class="text-xs-center">{{ props.item.fecha }}</td>
                <td class="text-xs-center"><span :class="props.item.classDate">{{ props.item.fechaVencimiento }}</span></td>
                <!--Codigo de pais = de-DE porque con es-ES no pone punto de millar para valores menores a 10.000-->
                <td class="text-xs-right"><span :class="props.item.class">{{ Number(props.item.importe).toLocaleString('de-DE',formatterOptions) }} </span></td>
                </template>
            </v-data-table>
            <v-data-table
              v-if="windowSize.x < 960"
                
                :items="custLedgerEntries"
                class="elevation-1"
                hide-actions
                hide-headers
            >
                <template v-slot:items="props">
                  <v-card class="elevation-1 mb-1 mt-1">
                    <v-layout wrap row>
                      <v-flex xs12 >
                        <v-card-title dense style="padding-bottom: 0px;"> <span class="cardTitleGrid bold-text">{{props.item.tipoDocumento}}</span>  <span class="itemIdCard subtitleGrid"> &nbsp&nbsp{{props.item.documento }}</span> </v-card-title> 
                      </v-flex>
                        <v-flex xs8>
                          <v-container pb-0>
                          <div class="subtitleGrid"><span class="itemIdCard"> Dirección envío: {{ props.item.direccionEnvio }} </span></div>
                          <div class="subtitleGrid"><span class="itemIdCard"> Fecha: {{ props.item.fecha }} </span></div>
                          <div class="subtitleGrid "><span class="itemIdCard"> Fecha vto: <span :class="props.item.classDate">{{ props.item.fechaVencimiento }}</span> </span></div>
                          </v-container>
                          
                        </v-flex>
                        <v-flex xs4>
                          <v-container pb-0>
                            <div class="subtitleGrid bold-text text-xs-right">&nbsp</div>
                            <div class="subtitleGrid bold-text text-xs-right"> Importe pendiente: <span :class="props.item.class">{{ Number(props.item.importe).toLocaleString('de-DE',formatterOptions) }}</span></div>
                          </v-container>
                        </v-flex>   
                    </v-layout>
                    <br>
                </v-card>
                </template>
            </v-data-table>
            <v-layout wrap row pt-2>
              <v-flex xs12 class="text-xs-right">
                <span class="bold-text ">Total: </span> {{Number(total).toLocaleString('de-DE',formatterOptions)}}€
              </v-flex>
            </v-layout>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="detail = false"
          >
            Volver
          </v-btn>
        </v-card-actions>
    </v-card>
      <v-card v-if="!detail">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Información de cliente
          <v-btn
            class="closeBtn"
            icon
            variant="text"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
        <v-layout wrap align-center v-if="($store.state.customers[this.$store.state.selectedCustIndex])">
            <v-flex xs12>
                <v-input
                prepend-icon="account_circle"
                >
                {{cust.Name}} {{cust.Name2}}
                </v-input>
            </v-flex>
            <v-flex xs12 v-if="cust.alias && (cust.alias != cust.Name)">
                <v-input
                >
                <span lass=lightText> ({{cust.alias}}) </span>
                </v-input>
            </v-flex>
            <v-flex xs12 v-if="cust.address || cust.address2">
                <v-input
                prepend-icon="home"
                >
                {{cust.address}}, {{cust.address2}}
                </v-input>
            </v-flex>
            <v-flex xs12 v-if="cust.email">
                <v-input
                prepend-icon="email"
                >
                {{cust.email}}
                </v-input>
            </v-flex>
            <v-flex xs12 v-if="cust.credito != undefined">
                <span class="creditlbl">Cr. max.:</span>
                <v-input
                v-if="parseFloat(cust.balance) <= parseFloat(cust.credito)"
                prepend-icon="mdi-cash-multiple"
                >
                </v-input>
                <v-input
                v-if="parseFloat(cust.balance) > parseFloat(cust.credito)"
                prepend-icon="mdi-cash-multiple"
                style="color: red"
                >
                {{Number(cust.credito).toLocaleString('de-DE',formatterOptions)}} €
                </v-input>
            </v-flex>
            <v-flex xs12 v-if="(cust.balance != undefined)">
                <span class="balancelbl">Saldo:</span>
                <v-input
                prepend-icon="mdi-cash-multiple"
                >
                {{Number(cust.balance).toLocaleString('de-DE',formatterOptions)}} € &nbsp;&nbsp;&nbsp;<v-icon color='blue' @click="getCustLedgerEntries()">list</v-icon>
                </v-input>
            </v-flex>
            <v-flex xs12 v-if="cust.phone">
                <v-input
                prepend-icon="phone"
                >
                {{cust.phone}}
                </v-input>
            </v-flex>
            <v-flex xs12 v-if="cust.addresses && cust.addresses.length">
                <addresses/>
            </v-flex>
        </v-layout>
        </v-container>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!--v-btn
            color="primary"
            flat
            @click="close"
          >
            Cancelar
          </v-btn-->
          <v-btn
            color="primary"
            flat
            @click="closeOK"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
</template>
<script>
import addresses from '@/components/addresses.vue'
export default {
    name: 'dialogCustInfo',
    components:{
        addresses
    },
    data () {
      return {
        formatterOptions: {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        },
        total: 0,
        detail: false,
        headers: [
          {
            text: 'Tipo Documento',
            align: 'start',
            sortable: true,
            value: 'tipoDocumento',
          },
          {
            text: 'Documento',
            align: 'start',
            sortable: true,
            value: 'documento',
          },
          {
            text: 'Fecha',
            align: 'start',
            sortable: true,
            value: 'fecha',
          },
          {
            text: 'Fecha vto.',
            align: 'start',
            sortable: true,
            value: 'fechaVencimiento',
          },
          {
            text: 'Importe',
            align: 'start',
            sortable: true,
            value: 'importe',
          },
        ],
        shipToAddress: ''
      }
    },
    methods:{
        close(){
            this.dialog = false;                       
        },
        closeOK(){
            this.dialog = false;
        },
        shipToAddressesLabel(item){
            if (item.code != ''){
                return item.name + ' | ' + item.address;
            } else {
                return '';
            }
        },
        getCustLedgerEntries(){
            var url = this.ApiBaseUrlNETCore + "cust/custLedgerEntries/";
            var custNo = '';
            if (this.$route.name == 'controldocumentos')
                custNo = this.$store.state.tempCust.no;
            else
                custNo = this.$store.state.customers[this.$store.state.selectedCustIndex].no;
            this.total = 0;
            this.axios.post(url, {no : custNo },{headers: {"Content-Type": "application/json"}}) //API
            .then(response => {          
                console.log(response.data);
                this.$store.state.custLedgerEntries = JSON.parse(response.data);
                this.$store.state.custLedgerEntries.forEach(entry => {
                    this.total += parseFloat(entry.importe);
                    if (entry.importe < 0) entry.class = 'unfavorable';
                    else if (entry.importe == 0) entry.class = '';
                    else entry.class = 'favorable';

                    var d = new Date(entry.fechaVencimiento);
                    if (d < new Date()) entry.classDate = 'unfavorable';
                    else entry.classDate = 'favorable';

                    if (entry.tipoDocumento == 'Payment') entry.tipoDocumento = 'Pago';
                    else if (entry.tipoDocumento == 'Invoice') entry.tipoDocumento = 'Factura';
                    else if (entry.tipoDocumento == 'Credit Memo') entry.tipoDocumento = 'Abono';
                    else if (entry.tipoDocumento == 'Finance Charge Memo') entry.tipoDocumento = 'Docs. interés';
                    else if (entry.tipoDocumento == 'Reminder') entry.tipoDocumento = 'Recordatorio';
                    else if (entry.tipoDocumento == 'Refund') entry.tipoDocumento = 'Reembolso';
                    else if (entry.tipoDocumento == 'Bill') entry.tipoDocumento = 'Efecto';

                    entry.fecha = this.formatDate(entry.fecha);
                    entry.fechaVencimiento = this.formatDate(entry.fechaVencimiento);
                });
                this.detail = true;
            })
            .catch(function (error) {
                // handle error
                //console.log(error);                
            })
            .finally(function () {                
            });
        }
    },
    computed:{
      custLedgerEntries:{
        get(){
          console.log(this.shipToAddress);
          if (this.shipToAddress != '')
            return this.$store.state.custLedgerEntries.filter(mov =>{
              return mov.codDireccionEnvio == this.shipToAddress;
            });
          else 
            return this.$store.state.custLedgerEntries;
        }
      },
      shipToAddresses:{
            get(){
                var res = [{ code: '', name: '', address: ''}];
                res = res.concat(this.$store.state.customers[this.$store.state.selectedCustIndex].addresses);
                return res;
            },
        },
      windowSize:{
            get(){
                return this.$store.state.windowSize;
            },
            set(value){
                this.$store.state.windowSize = value;
            }
        },
      cust: {
        get(){
          if (this.$route.name == 'controldocumentos')
            return this.$store.state.tempCust;
          else
            return this.$store.state.customers[this.$store.state.selectedCustIndex]
        }
      },
      dialog: {
        get(){
          return this.$store.state.dialogCustInfo;
        },
        set(value){
          this.$store.state.dialogCustInfo = value;
        }
      }
    }
}
</script>
<style scoped>
.unfavorable{
    color: red;
}
.favorable{
    color: green;
}
.bold-text{
  font-weight: 500;
}
.balancelbl{
  font-weight: bold;
  position: absolute;
  margin-left: -10px;
}
.creditlbl{
  font-weight: bold;
  position: absolute;
  margin-left: -30px;
}
.closeBtn{
  position: absolute;
  right: 0px;
}
</style>